import { Button, FoodsIcon } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type AddLeverActionProps = {
    onClick(): void;
};

export const AddLeverAction = (props: AddLeverActionProps) => {
    const { t } = useTranslation();

    return (
        <Button
            variant="text"
            startIcon={<FoodsIcon icon="plus" size={1.5} />}
            onClick={props.onClick}
            sx={(theme) => ({
                mt: 2.5,
                minHeight: theme.spacing(8),
                border: `1px dashed ${theme.palette.primary[600]}`,
                borderRadius: 1.5,
                color: theme.palette.primary[600],
                backgroundColor: theme.palette.primary[50],
                "&:hover": { backgroundColor: theme.palette.primary[100] },
            })}
        >
            {t("settings.csr.overview.add_lever", "Add a lever")}
        </Button>
    );
};
